























import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Action } from 'vuex-class'

// Mixins
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

@Component
export default class ConfirmPhoneNumberForm extends Mixins(Form, Errors)  {
  code: string = null
  resent: boolean = false
  verified: boolean = false

  @Prop({ type: String }) phone!: string
  @Action('updatePhoneNumber', { namespace: 'user' }) updatePhoneNumber
  @Action('checkPhoneNumber', { namespace: 'user' }) checkPhoneNumber

  close() {
    this.$emit('close', { code: this.code, valid: this.formValid, verified: this.verified })
  }

  async resend() {
    try {
      this.updatePhoneNumber(this.phone)
      this.resent = true
      setTimeout(() => {
        this.resent = false
      }, 10000)
    } catch (error) {
      this.displayErrors(error)
    }
  }

  async submitForm() {
    try {
      await this.checkPhoneNumber(this.code)
      this.verified = true
      this.close()
    } catch (error) {
      this.displayErrors(error)
      this.code = null
    }
  }
}
